import { Article } from '@generated'
import { getKontentImage } from '@lib/kontent'
import { cn } from '@lib/cn'
import { Image } from '@components/gassan-ui'

type ProductGalleryProps = {
  data: Article
  onSelectImage: (url: string) => void
}

const ProductGallery = ({ data, onSelectImage }: ProductGalleryProps) => {
  const { modelName } = data

  const imagesSlider = data.images.filter((url) => !url.includes('_360')).slice(0, 4)

  return (
    <div className={cn('hidden', ' lg:mt-[30px] lg:grid lg:grid-cols-12 lg:gap-1')}>
      {imagesSlider.map((url, idx) => (
        <div key={idx} className="col-span-3">
          <button onClick={() => onSelectImage(url)} className="aspect-square h-full w-full">
            <Image
              sources={[getKontentImage(url, { width: 750, height: 750 })]}
              alt={`Rolex ${modelName} - ${idx + 1}`}
              className="h-full w-full"
            />
          </button>
        </div>
      ))}
    </div>
  )
}

export default ProductGallery
